import styled from 'styled-components'
import FlagIcon from 'components/Common/FlagIcon'
import { CheckedIcon } from 'components/Common/Icons'

const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
`
const ListItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0 13px;
  font: var(--typography-14-16-semibold);
  color: var(--color-night);
  flex: 1;
  box-sizing: border-box;
  height: 48px;
  border-bottom: 1px solid transparent;
`
const ListItem = styled.li`
  display: flex;
  align-items: center;
  padding: 0 8px;
  gap: 12px;
  border-radius: 8px;
  cursor: pointer;
  box-sizing: border-box;

  &:not(:last-child) ${ListItemContent} {
    border-bottom: 1px solid var(--color-sw-10);
  }
`

const LanguagesList = ({ list, value, onSelect }) => {
  const handleItemClick = (item, event) => {
    event.stopPropagation()
    onSelect(item)
  }

  const handleMouseDown = event => {
    event.stopPropagation()
  }

  return (
    <List>
      {list.map(item => (
        <ListItem
          key={item.id}
          onClick={e => handleItemClick(item, e)}
          onMouseDown={handleMouseDown}
          data-testid={`onboarding-header-language-item-${item.locale}`}
        >
          <FlagIcon codeISO={item.locale} width={24} height={16} />
          <ListItemContent>
            {item.name} {value.locale === item.locale && <CheckedIcon />}
          </ListItemContent>
        </ListItem>
      ))}
    </List>
  )
}

export default LanguagesList
